import { ContractFunnel } from "features/subscription-process/pricing-process/types/interfaces";

// Fonction utilitaire pour créer un hash d'objet déterministe
export const createObjectHash = (obj: Record<string, any>): string => {
  // Fonction récursive pour normaliser les objets
  const normalizeObject = (value: any): any => {
    if (value === null || value === undefined) {
      return null;
    }

    if (Array.isArray(value)) {
      return value.map(item => normalizeObject(item));
    }

    if (typeof value === 'object') {
      const sortedKeys = Object.keys(value).sort();
      const normalized: Record<string, any> = {};
      for (const key of sortedKeys) {
        normalized[key] = normalizeObject(value[key]);
      }
      return normalized;
    }

    return value;
  };

  // Normaliser l'objet complet
  const normalizedObj = normalizeObject(obj);

  // Convertir en string de manière déterministe
  const str = JSON.stringify(normalizedObj);

  // Créer le hash avec DJB2
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
  }

  return Math.abs(hash).toString(16);
};

